import type { CSSProperties, ReactNode } from 'react'

/**
 * A call card's interactive wrapper: an immediate `tel:` link when the
 * organisation configured a direct number (the incumbent's instant-call path),
 * otherwise a button that opens the in-app voice/video component. Rendering
 * the wrapper rather than the button is what keeps that behaviour identical
 * across the three worlds.
 */
export default function CallTarget({
  instantPhone,
  onClick,
  className,
  style,
  children,
}: {
  instantPhone: string | null
  onClick: () => void
  className?: string
  style?: CSSProperties
  children: ReactNode
}) {
  if (instantPhone != null && instantPhone !== '') {
    return (
      <a href={'tel:' + instantPhone} className={className} style={style}>
        {children}
      </a>
    )
  }
  return (
    <button type="button" className={className} style={style} onClick={onClick}>
      {children}
    </button>
  )
}
